import { lazy } from 'react';

const ClosedPeriodsPage = lazy(() => import('../pages/ClosedPeriods.page'));
const ClosePeriodPage = lazy(() => import('../pages/ClosePeriod.page'));

const ClosedPeriodsRoutes = [
    {
        path: '/closed-periods',
        element: <ClosedPeriodsPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/closed-periods/add',
        element: <ClosePeriodPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ClosedPeriodsRoutes };
